export default {
      id: "arrow-go-right-usage",
      viewBox: "0 0 8 11",
      url: __webpack_public_path__ + "img/icons.159f8dce.svg#arrow-go-right",
      toString: function () {
        return this.url;
      }
    }